// TODO: this should be in web-commons or is it good enought to have it here
// duplicated in SA 2.0 MFE

const tagI18nMapper = {
  Agreement: 'tags.agreement',
  Disclaimer: 'tags.disclaimer',
  Glossary: 'tags.glossary',
  'Scope and Process': 'tags.scopeAndProcess',
  'Scope and Process Supplement': 'tags.scopeAndProcessSupplement',
  'Transmittal Letter': 'tags.transmittalLetter',
  BEV: 'tags.bev',
  FDD: 'tags.fdd',
  Financial: 'tags.financial',
  IT: 'tags.it',
  Tax: 'tags.tax',
};

export const getTranslationForDefaultTag = (text, t) => {
  return text && tagI18nMapper[text] ? t(tagI18nMapper[text]) : text;
};
